<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <!-- loading -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="{ visible: loading, text: loadingtext }"
    ></div>
    <div class="content">
      <div class="con-main">
        <div class="con-left">
          <div class="con-left-title">
            <div class="con-left-title-nav">
              <router-link :to="{ path: '/', query: { idx: 0 } }"
                >首页</router-link
              >
            </div>
            <div class="con-left-title-nav">></div>
            <div class="con-left-title-nav">
              <router-link :to="{ path: '/hdzq/list' }">活动专区</router-link>
            </div>
            <div class="con-left-title-nav">></div>
            <div class="con-left-title-nav">重庆市健康科普成果展示活动</div>
            <div class="con-left-title-btn">
              <el-button type="primary" size="small" @click="comeback"
                >返回上级</el-button
              >
            </div>
          </div>
          <div class="con-left-xq">
            <div class="xinhuodong">
              <div class="xinhuodong-title">
                <div class="xinhuodong-title-dbt">
                  重庆市健康科普成果展示活动
                </div>
                <div class="xinhuodong-title-xbt">
                  主办单位：重庆科普作家协会、重庆医科大学附属大学城医院、重庆医科大学附属第二医院、重庆市中医院、重庆医科大学附属儿童医院、重庆医科大学护理学院
                </div>
                <div class="xinhuodong-title-tgq">
                  <!-- <div class="xinhuodong-title-tgq-line">
                    <span>投稿数：</span>{{ tougaoshu }}
                  </div> -->
                  <div class="xinhuodong-title-tgq-line">
                    <span>截止日期：</span>{{ jiezhiriqi }}
                  </div>
                  <div class="xinhuodong-title-tgq-line">
                    <div
                      class="xinhuodong-title-tgq-line-btn xinhuodong-title-tgq-line-btn1"
                      @click="clicklijitougao"
                    >
                      立即投稿
                    </div>
                    <div
                      class="xinhuodong-title-tgq-line-btn xinhuodong-title-tgq-line-btn2"
                      @click="tiaozhuangrzx"
                    >
                      查看稿件
                    </div>
                  </div>
                </div>
              </div>
              <div class="xinhuodong-con">
                <el-tabs v-model="activeName" class="demo-tabs">
                  <el-tab-pane label="活动介绍" name="huodongjieshao">
                    <div class="hdjs-wz" v-html="huodongcontent"></div>
                  </el-tab-pane>
                  <el-tab-pane label="全部作品" name="quanbuzuopin">
                    <div class="zuopin-ul">
                      <div
                        class="zuopin-list"
                        v-for="(item, key) in zuopinlist"
                        :key="key"
                      >
                        <div class="zuopin-list-title">
                          {{ item.title }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          选题方向：{{ item.xtfx }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          作者单位：{{ item.org }}
                        </div>
                        <div class="zuopin-list-btns">
                          <div class="zuopin-list-btns-zz">
                            <el-icon :size="size" :color="color">
                              <User />
                            </el-icon>
                            <span>{{ item.wrname }}</span>
                          </div>
                          <el-button
                            type="primary"
                            :icon="Search"
                            @click="clickchakan(item.Id)"
                            >查看</el-button
                          >
                        </div>
                      </div>
                    </div>
                    <div class="con-main-nr-fy">
                      <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="fenye"
                      />
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="优秀作品" name="youxiuzuopin">
                    <div class="zuopin-ul">
                      <div
                        class="zuopin-list"
                        v-for="(item, key) in zuopinlistyouxiu"
                        :key="key"
                      >
                        <div class="zuopin-list-title">
                          {{ item.title }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          选题方向：{{ item.xtfx }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          作者单位：{{ item.org }}
                        </div>
                        <div class="zuopin-list-btns">
                          <div class="zuopin-list-btns-zz">
                            <el-icon :size="size" :color="color">
                              <User />
                            </el-icon>
                            <span>{{ item.wrname }}</span>
                          </div>
                          <el-button
                            type="primary"
                            :icon="Search"
                            @click="clickchakan(item.Id)"
                            >查看</el-button
                          >
                        </div>
                      </div>
                    </div>
                    <div class="con-main-nr-fy">
                      <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="totalyouxiu"
                        @current-change="fenyeyouxiu"
                      />
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
    <!-- 活动详情弹窗 -->
    <el-dialog v-model="dialogTableVisible" title="作品详情" width="800">
      <div class="zuopinxiangqing-jcxx">
        <div class="zuopinxiangqing-jcxx-title">基础信息</div>
        <div class="zuopinxiangqing-jcxx-con">
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">投稿题目：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.title
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">投稿人：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.wrname
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">作者单位：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.org
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">选题方向：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.xtfx
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">作品形式：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.zpxs
            }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="zuopinxiangqing-fj">
        <div class="zuopinxiangqing-jcxx-title">附件</div>
        <div class="zuopinxiangqing-fj-con">
          <div class="zuopinxiangqing-fj-cons">
            <el-icon :size="'16'"> <Link /> </el-icon
            ><a :href="zuopinobj.zuopin.zpfile">作品下载</a>
          </div>
        </div>
      </div> -->
    </el-dialog>
    <!-- 投稿弹窗 -->
    <el-dialog v-model="dialogTableVisibletougao" title="投稿" width="800">
      <div class="tougao-buzou">
        <el-steps :active="tougaoactive" finish-status="success">
          <el-step title="作者投稿承诺书" />
          <el-step title="投稿格式须知" />
          <el-step title="上传稿件" />
        </el-steps>
      </div>
      <div class="tougao-con">
        <!-- 第一步 -->
        <div class="tougao-cons" v-show="tougaoactive == 0">
          <div class="tougao-cons-duanluo">
            <p>
              1.主办方对研究成果有编辑删改权，不同意删改或持有异议的作者请在稿件中特别注明或及时与主办方联系。
            </p>
            <p>
              2.所投研究成果须严格遵守《中华人民共和国著作权法》相关规定，严禁抄袭或剽窃他人作品，引用、借鉴他人研究成果必须注明出处。一旦发现抄袭、造假等不良行为，将取消参与资格。因活动参与者个人单方面原因引起的侵权纠纷及其他法律责任，由其自行承担一切责任及后果。
            </p>
            <p>
              3.所有研究成果一经投稿，便视为作者授权主办方免费将作品展示到活动官网上，并供他人阅览和下载，将作品制作成专辑并出版发行，允许在其或与其合作的新媒体网络平台使用该作品，包括但不仅限于微信公众号、App、网站等，主办方有权将含该作品的专辑通过通信网络和互联网等信息网络进行复制、出版、发行、传播和销售。
            </p>
          </div>
          <div class="tougao-cons-caozuo">
            <div class="tougao-cons-caozuos">
              <el-checkbox v-model="tougaochecked" label="我同意以上协议" />
            </div>
            <div class="tougao-cons-caozuos tougao-cons-caozuos-btn">
              <el-button
                @click="click1"
                :disabled="!tougaochecked"
                type="primary"
                >下一步</el-button
              >
            </div>
          </div>
        </div>
        <!-- 第二部 -->
        <div class="tougao-cons" v-show="tougaoactive == 1">
          <div class="tougao-cons-duanluo">
            <p class="tougao-cons-duanluo-title">1.投稿作品形式：</p>
            <p>
              （1）文字类：包含科普文章、科普论文、课题研究成果报告等，文字作品复制必须控制在25%以内。文字类作品字数不超过2000字。
            </p>
            <p>
              （2）视频类：包含短视频、纪录片、微电影、微课等，应确保视频的原创性，杜绝版权纠纷，并且不涉及商业宣传。作品应当符合社会主义核心价值观，并保证科学性。视频提交格式须为MP4，分辨率不小于1080p，时长控制在3~5分钟，文件大小不超过700M。
            </p>
            <p class="tougao-cons-duanluo-title">
              2.健康科普文章样式（供参考）
            </p>
            <p>标题自拟（黑体小二，居中）</p>
            <p>主要作者（楷体五号，居中）</p>
            <p>单位（楷体五号，居中）</p>
            <p>
              引言/摘要内容：简述文章内容（150—200字，宋体5号，首行缩进2字符）
            </p>
            <p>正文内容：宋体五号，首行缩进2字符，单倍行距，2000字以内。</p>
          </div>
          <div class="tougao-cons-caozuo">
            <div class="tougao-cons-caozuos tougao-cons-caozuos-btn">
              <el-button @click="tougaoactive = 0">上一步</el-button
              ><el-button @click="click2" type="primary">下一步</el-button>
            </div>
          </div>
        </div>
        <!-- 第三部 -->
        <div class="tougao-cons" v-show="tougaoactive == 2">
          <div class="tougao-cons-duanluo">
            <el-form
              label-width="100px"
              :model="formLabelAlign"
              :rules="baseRules"
              ref="ruleFormRef"
            >
              <el-form-item label="投稿题目" required prop="title">
                <el-input
                  v-model="formLabelAlign.title"
                  placeholder="请输入投稿题目"
                />
              </el-form-item>
              <el-form-item label="作者姓名" required prop="wrname">
                <el-input
                  v-model="formLabelAlign.wrname"
                  placeholder="请输入作者姓名"
                />
              </el-form-item>
              <el-form-item label="作者单位" required prop="org">
                <el-input
                  v-model="formLabelAlign.org"
                  placeholder="请输入作者单位"
                />
              </el-form-item>
              <el-form-item label="作品形式" required prop="zpxs">
                <el-select
                  v-model="formLabelAlign.zpxs"
                  placeholder="请选择作品形式"
                  style="width: 660px"
                >
                  <el-option
                    v-for="item in optionszpxs"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="选题方向" required prop="xtfx">
                <el-select
                  v-model="formLabelAlign.xtfx"
                  placeholder="请选择选题方向"
                  style="width: 660px"
                >
                  <el-option
                    v-for="item in optionsxtfx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                class="isfabiao"
                label="是否发表在《健康科普》报纸"
                required
              >
                <el-switch
                  v-model="formLabelAlign.sffbflag"
                  active-text="是"
                  inactive-text="否"
                  @change='changesffb'
                />
                <div class="isfabiao-txt" v-show="formLabelAlign.sffbflag == true">
                  *默认发表至《健康人报·健康科普》报纸，无需发表点击按钮取消
                </div>
                
                <el-popover
                  placement="bottom"
                  title="报刊简介"
                  :width="290"
                  trigger="click"
                  content="《健康人报·健康科普》（国内统一刊号：CN50-0018）是面向全国公开发行的大众健康类报纸。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，传递卫生健康领域前沿探索、信息技术，是全国重点健康类报纸。"
                > 
                <template #reference>
                  <div class="isfabiao-baozhi">查看报刊简介</div>
                </template>
                </el-popover>
              </el-form-item>
              <el-form-item label="上传报名表" required>
                <el-upload
                  v-model:file-list="fileList"
                  class="upload-demo"
                  action="#"
                  list-type="text"
                  :limit="1"
                  accept=".doc, .docx"
                  :on-exceed="handleExceed"
                  :before-upload="handlePreview"
                  :before-remove="handleRemove"
                  :http-request="upload"
                >
                  <el-button type="primary">上传报名表</el-button>
                  <template #tip>
                    <div class="el-upload__tip">
                      <a
                        href="https://ketanghd-1304761361.cos.ap-nanjing.myqcloud.com/mb/%E9%87%8D%E5%BA%86%E5%B8%82%E5%81%A5%E5%BA%B7%E7%A7%91%E6%99%AE%E6%88%90%E6%9E%9C%E5%B1%95%E7%A4%BA%E6%8A%A5%E5%90%8D%E8%A1%A8.zip"
                        >报名表下载</a
                      >
                      <div>请上传.doc或者.docx格式文件</div>
                    </div>
                  </template>
                </el-upload>
              </el-form-item>

              <el-form-item label="上传文件" required>
                <el-upload
                  v-model:file-list="fileListwj"
                  class="upload-demo"
                  action="#"
                  list-type="text"
                  :limit="1"
                  accept=".doc, .docx,.mp4"
                  :on-exceed="handleExceedwj"
                  :before-upload="handlePreviewwj"
                  :before-remove="handleRemovewj"
                  :http-request="uploadwj"
                >
                  <el-button type="primary">上传文件</el-button>
                  <template #tip>
                    <div class="el-upload__tip">
                      文字类请上传.doc或者.docx格式文件；视频类请上传.mp4格式文件，分辨率不小于1080p，时长控制在3~5分钟，文件大小不超过700M。
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="tougao-cons-caozuo">
            <div class="tougao-cons-caozuos tougao-cons-caozuos-btn">
              <el-button @click="tougaoactive = 1">上一步</el-button
              ><el-button @click="submitinfo(ruleFormRef)" type="primary"
                >提交待审</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { User } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import COS from "cos-js-sdk-v5";
// vuex
import { useStore } from "vuex";
const store = useStore();
// router
import { useRouter } from "vue-router";
const router = useRouter();
import { get, post } from "@/utils/index";
import { ref, reactive, getCurrentInstance } from "vue";
import {
  Delete,
  Edit,
  Search,
  Share,
  Upload,
  Link,
} from "@element-plus/icons-vue";
const { proxy } = getCurrentInstance();
// loading
let loading = ref(false);
let loadingtext = ref("文件上传中，请等待...");
// tab初始值
let activeName = ref("huodongjieshao");
// 活动的html代码
let huodongcontent = ref("");
let jiezhiriqi = ref("");
let tougaoshu = ref(0);
// 分页 全部作品
let psize = ref(9);
let pindex = ref(1);
let total = ref(0);
let psizeyouxiu = ref(9);
let pindexyouxiu = ref(1);
let totalyouxiu = ref(0);
let zuopinleixing = ref(0); //0 全部   2优秀
// 是否显示活动详情弹窗
let dialogTableVisible = ref(false);
let dialogTableVisibletougao = ref(false);
// 投稿弹窗
let tougaoactive = ref(0);
let tougaochecked = ref(false);
// 作品形式
const optionszpxs = [
  {
    value: "文字类",
    label: "文字类",
  },
  {
    value: "视频类",
    label: "视频类",
  },
];
// 选题方向
const optionsxtfx = [
  {
    value: "心理健康类科普",
    label: "心理健康类科普",
  },
  {
    value: "健康科普与健康教育人才培养",
    label: "健康科普与健康教育人才培养",
  },
  {
    value: "用药科普",
    label: "用药科普",
  },
  {
    value: "过敏科普",
    label: "过敏科普",
  },
  {
    value: "慢病防治类科普",
    label: "慢病防治类科普",
  },
  {
    value: "中医类科普",
    label: "中医类科普",
  },
  {
    value: "护理类科普",
    label: "护理类科普",
  },
  {
    value: "儿科类科普",
    label: "儿科类科普",
  },
];
let formLabelAlign = reactive({
  wzid: router.currentRoute.value.query.id,
  hdname: "重庆市健康科普成果展示活动",
  title: "",
  org: "",
  zpxs: "",
  xtfx: "",
  bmbfile: "",
  zpfile: "",
  sffbflag:false,
  sffb: '否',
});
const ruleFormRef = ref();
const baseRules = {
  title: [
    { required: true, message: "投稿题目不能为空", trigger: "blur" },
    { min: 3, max: 50, message: "标题长度3-50字之间", trigger: "blur" },
  ],
  wrname: [
    { required: true, message: "作者姓名不能为空", trigger: "blur" },
    { min: 3, max: 50, message: "作者姓名长度50字以内", trigger: "blur" },
  ],
  org: [
    { required: true, message: "作者单位不能为空", trigger: "blur" },
    { min: 3, max: 50, message: "作者单位长度3-50字之间", trigger: "blur" },
  ],
  zpxs: [{ required: true, message: "请选择作品形式", trigger: "blur" }],
  xtfx: [{ required: true, message: "请选择选题方向", trigger: "blur" }],
};
// 全部作品列表
let zuopinlist = reactive([]);
let zuopinlistyouxiu = reactive([]);
let zuopinobj = reactive({
  zuopin: {},
});
// 上传
let fileList = ref([]);
let fileListwj = ref([]);
let form = reactive({
  title: "", //报名表名
  titlewj: "", //文件名
});
// 上传桶的filename  唯一key 报名表
let filename = "";
// 上传桶的filename  唯一key 文件
let filenamewj = "";
// 实例
const cos = new COS({
  // getAuthorization 必选参数
  getAuthorization: function (options, callback) {
    // 异步获取临时密钥
    let url = "http://114.117.204.133:8004/api/User/GetTencentSST"; // url 替换成您自己的后端服务
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    //发送合适的请求头信息
    xhr.setRequestHeader(
      "Content-Type",
      "application/json-patch+json;charset=UTF-8"
    );
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token") || ""
    );
    xhr.onload = function (e) {
      let resdata, credentials;
      try {
        resdata = JSON.parse(e.target.responseText);
        credentials = resdata.data.Credential.Credentials;
      } catch (e) {}
      if (!resdata || !credentials) {
        return console.error("credentials invalid");
      }

      callback({
        TmpSecretId: credentials.TmpSecretId,
        TmpSecretKey: credentials.TmpSecretKey,
        SecurityToken: credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: resdata.data.Credential.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: resdata.data.Credential.ExpiredTime, // 时间戳，单位秒，如：1580000000
      });
    };
    xhr.send();
  },
});

//点击是否发表
const changesffb=val=>{
  if(val){
    formLabelAlign.sffb='是'
  }else{
    formLabelAlign.sffb='否'
  }
}

// 获取全部作品
const getallzuopin = () => {
  post("/api/Hd/GetHdJkkpcgList", {
    keyword: "",
    yx: zuopinleixing.value,
    page: pindex.value,
    psize: psize.value,
  }).then((res) => {
    zuopinlist.push(...res.data);
    total.value = res.total;
  });
};
getallzuopin();
// 获取优秀作品
const getallzuopinyouxiu = () => {
  post("/api/Hd/GetHdJkkpcgList", {
    keyword: "",
    yx: 2,
    page: pindexyouxiu.value,
    psize: psizeyouxiu.value,
  }).then((res) => {
    zuopinlistyouxiu.push(...res.data);
    totalyouxiu.value = res.total;
  });
};
getallzuopinyouxiu();

// 获取详情
const getdetail = () => {
  get("/api/NewsPaper/GetNewsForm", {
    id: router.currentRoute.value.query.id,
  }).then((res) => {
    huodongcontent.value = res.data.NewsContent;
    jiezhiriqi.value = res.data.NewsTag;
  });
};
getdetail();

// 获取投稿数量
const gettougaoshu = () => {
  get("/api/Hd/GetHdJkkpcgCount").then((res) => {
    tougaoshu.value = res.data;
  });
};
gettougaoshu();

// 点击立即投稿判断登录
const clicklijitougao = () => {
  let token = window.localStorage.getItem("token") || "";
  if (token && token != "") {
    dialogTableVisibletougao.value = true;
  } else {
    // 清除token
    window.localStorage.removeItem("token");
    // 保存当前地址以便登录后返回
    window.localStorage.setItem("loginurl", window.location.href);
    ElMessage({
      message: "请登录",
      type: "warning",
      duration: 1000,
      onClose: () => {
        // 跳转登录页
        router.push({
          path: "/login",
          query: {},
        });
      },
    });
  }
};

// 到第二部
const click1 = () => {
  tougaoactive.value = 1;
};
// 到第3部
const click2 = () => {
  tougaoactive.value = 2;
};

// 提交待审
const submitinfo = (formEl) => {
  if (!formEl) return;
  if (form.title == "") {
    ElMessage({
      message: "请上传报名表",
      duration: 1000,
    });
    return;
  }
  if (form.titlewj == "") {
    ElMessage({
      message: "请上传文件",
      duration: 1000,
    });
    return;
  }
  formEl.validate((valid) => {
    // 通过验证规则 true
    if (valid) {
      post("/api/User/SubHdJkkpcg", formLabelAlign).then((res) => {
        ElMessage({
          message: "提交成功，等待审核",
          duration: 1000,
          onClose: () => {
            formLabelAlign.title = "";
            formLabelAlign.org = "";
            formLabelAlign.zpxs = "";
            formLabelAlign.xtfx = "";
            formLabelAlign.bmbfile = "";
            formLabelAlign.zpfile = "";
            tougaoactive.value = 0;
            fileList.value = [];
            fileListwj.value = [];
            dialogTableVisibletougao.value = false;
          },
        });
      });
    }
  });
};

// 上传报名表
const upload = (params) => {
  // 自动标题
  form.title = params.file.name.split(".")[0];
  // 文件名不唯一
  filename = params.file.name.split(".")[0] + Date.now();
  // formLabelAlign.bmbfile =
  //   "https://yuanpingjia-com-cn-1304761361.cos.ap-chongqing.myqcloud.com/tougao/%E5%8A%A0%E5%90%88%E6%8A%95%E7%A8%BF%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.docx";
  cos.putObject(
    {
      Bucket: "ketanghd-1304761361" /* 填入您自己的存储桶，必须字段 */,
      Region: "ap-nanjing" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
      Key:
        "hd/" +
        filename +
        "." +
        params.file.name.split(
          "."
        )[1] /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
      Body: params.file,
    },
    function (err, data) {
      if (data.statusCode === 200) {
        formLabelAlign.bmbfile = "https://" + data.Location;
      } else {
        ElMessage({
          message: "上传失败：" + err,
          type: "error",
        });
      }
    }
  );
};
// 上传文件
const uploadwj = (params) => {
  // loding
  loading.value = true;
  // 自动标题
  form.titlewj = params.file.name.split(".")[0];
  // 文件名不唯一
  filenamewj = params.file.name.split(".")[0] + Date.now();
  // formLabelAlign.zpfile =
  //   "https://yuanpingjia-com-cn-1304761361.cos.ap-chongqing.myqcloud.com/tougao/%E5%8A%A0%E5%90%88%E6%8A%95%E7%A8%BF%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.docx";
  cos.putObject(
    {
      Bucket: "ketanghd-1304761361" /* 填入您自己的存储桶，必须字段 */,
      Region: "ap-nanjing" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
      Key:
        "hd/" +
        filenamewj +
        "." +
        params.file.name.split(
          "."
        )[1] /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
      Body: params.file,
    },
    function (err, data) {
      // 关闭loding
      loading.value = false;
      if (data.statusCode === 200) {
        formLabelAlign.zpfile = "https://" + data.Location;
      } else {
        ElMessage({
          message: "上传失败：" + err,
          type: "error",
        });
      }
    }
  );
};
// 超出限制
const handleExceed = (file) => {
  ElMessage({
    message: "只能上传一个文档",
    duration: 1000,
    type: "warning",
  });
};
const handleExceedwj = (file) => {
  ElMessage({
    message: "只能上传一个文档",
    duration: 1000,
    type: "warning",
  });
};

// 上传之前
const handlePreview = (file) => {
  // 此处可以限制大小
  // ElMessage({
  //   message: "图片超出大小",
  //   duration: 1000,
  //   type: 'warning',
  // });
  // return false
};
const handlePreviewwj = (file) => {
  // 此处可以限制大小
  // console.log(file);
  const isLt2M = file.size / 1024 / 1024 < 700;
  if (!isLt2M) {
    ElMessage({
      message: "文件超出大小，请上传700M以内大小的文件",
      duration: 1000,
      type: "warning",
    });
    return false;
  }
};

// 删除文件
const handleRemove = (uploadFile, uploadFiles) => {
  // pictureUrl.value = "";
  form.title = "";
};
const handleRemovewj = (uploadFile, uploadFiles) => {
  // pictureUrl.value = "";
  form.titlewj = "";
};

// 查看详情
const clickchakan = (id) => {
  // 根据id获取详情
  get("/api/Hd/GetHdJkkpcgDet", {
    id: id,
  }).then((res) => {
    //zuopinlist.push(...res.data)
    zuopinobj.zuopin = res.data;
  });
  dialogTableVisible.value = true;
};

// 分页 全部作品
const fenye = (value) => {
  pindex.value = value;
  getallzuopin();
};
const fenyeyouxiu = (value) => {
  pindexyouxiu.value = value;
  getallzuopinyouxiu();
};

// 返回
const comeback = () => {
  router.push({
    path: "/hdzq/list",
  });
};
// 查看投稿
const tiaozhuangrzx = () => {
  let token = window.localStorage.getItem("token") || "";
  if (token && token != "") {
    router.push({
      path: "/pchd",
      query: {
        idx: -1,
      },
    });
  } else {
    // 清除token
    window.localStorage.removeItem("token");
    // 保存当前地址以便登录后返回
    window.localStorage.setItem("loginurl", window.location.href);
    ElMessage({
      message: "请登录",
      type: "warning",
      duration: 1000,
      onClose: () => {
        // 跳转登录页
        router.push({
          path: "/login",
          query: {},
        });
      },
    });
  }
};
</script>

<style scoped>
::v-deep(.isfabiao .el-form-item__label) {
  width: 210px !important;
  justify-content: flex-start;
}
::v-deep(.el-upload__tip) {
  display: flex;
}
::v-deep(.el-steps) {
  width: 100%;
}
::v-deep .el-carousel__container {
  height: 200px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
a:link,
a:visited {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #777;
}
.con-left {
  width: 100%;
  height: auto;
  float: left;
  padding-bottom: 50px;
}

.con-left-title {
  font-weight: bold;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.con-left-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-left-title-nav {
  float: left;
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
  font-size: 14px;
}

.con-left-fy {
  padding: 30px 0;
}

.con-left-title-btn {
  display: flex;
  align-items: center;
  float: right;
}

.xinhuodong {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 20px 0 0 0;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 8px rgba(6, 56, 115, 0.1);
}
.xinhuodong-title {
  position: relative;
  width: 1160px;
  height: 210px;
  background-image: url("../../assets/img/hdzq/activitybj.c75e0b23.png");
  background-size: 100% 100%;
  margin-bottom: 20px;
}
.xinhuodong-title-dbt {
  position: absolute;
  left: 20px;
  top: 55px;
  width: 660px;
  line-height: 36px;
  font-size: 22px;
}
.xinhuodong-title-xbt {
  position: absolute;
  left: 20px;
  top: 100px;
  width: 660px;
  font-size: 18px;
  color: #666;
}
.xinhuodong-title-tgq {
  position: absolute;
  top: 30px;
  right: 50px;
  width: 360px;
  height: 150px;
  background: #fff;
  box-shadow: 0 0 8px rgba(6, 56, 115, 0.1);
  border-radius: 5px;
  padding: 10px 50px;
  box-sizing: border-box;
}
.xinhuodong-title-tgq-line {
  font-size: 18px;
  margin: 18px 0;
}
.xinhuodong-title-tgq-line > span {
  color: #999;
}
.xinhuodong-title-tgq-line-btn {
  width: 110px;
  height: 50px;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  border-radius: 5px;
  float: left;
  cursor: pointer;
}
.xinhuodong-title-tgq-line-btn:after {
  content: "";
  display: table;
  clear: both;
}
.xinhuodong-title-tgq-line-btn:hover {
  opacity: 0.9;
}
.xinhuodong-title-tgq-line-btn1 {
  background: #2c5dfe;
  margin-right: 20px;
}
.xinhuodong-title-tgq-line-btn2 {
  background: #67c23a;
}
.zuopin-list {
  display: inline-block;
  position: relative;
  width: calc(33.33% - 20px);
  height: auto;
  margin: 10px;
  padding: 10px;
  font-size: 14px;
  line-height: 20px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  vertical-align: top;
  box-sizing: border-box;
}
.zuopin-list-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zuopin-list-subtitle {
  padding: 5px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zuopin-list-btns {
  border-top: 1px solid #ddd;
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.zuopin-list-btns-zz {
  width: 250px;
  height: 40px;
  display: flex;
  align-items: center;
}
.zuopin-list-btns-zz > span {
  padding-left: 5px;
}
.con-main-nr-fy {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}

.zuopinxiangqing-jcxx-title {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  font-weight: bold;
}
.zuopinxiangqing-jcxx-cons:after {
  content: "";
  display: table;
  clear: both;
}
.zuopinxiangqing-jcxx-cons-sp1 {
  float: left;
  width: 100px;
  height: 26px;
  line-height: 26px;
}
.zuopinxiangqing-jcxx-cons-sp2 {
  float: right;
  width: calc(100% - 100px);
  min-height: 26px;
  line-height: 26px;
}
.zuopinxiangqing-jcxx-con {
  padding: 10px 0;
}
.zuopinxiangqing-fj a:link,
.zuopinxiangqing-fj a:visited {
  color: #2c5dfe;
}
.zuopinxiangqing-fj a:hover {
  text-decoration: underline;
}
.zuopinxiangqing-fj-con {
  padding: 10px 0;
}
.zuopinxiangqing-fj-cons {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
}
.zuopinxiangqing-fj-cons a {
  margin-left: 5px;
}
.zuopinxiangqing-fj {
  padding-top: 20px;
}

/* 步骤弹窗 */
.tougao-buzou {
  width: 100%;
  display: flex;
  justify-content: center;
}
.tougao-con {
  padding: 30px 0;
}
.tougao-cons-duanluo > p {
  line-height: 24px;
  margin: 8px 0;
}
.tougao-cons-caozuos-btn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.tougao-cons-duanluo-title {
  font-weight: bold;
}
.baomingbiao {
  position: relative;
}
.baomingbiao a {
  position: absolute;
  left: 18px;
  top: 36px;
}
.baomingbiao a:link,
.baomingbiao a:visited {
  color: #2c5dfe;
  text-decoration: underline;
}
.el-upload__tip a {
  margin: 0 10px 0 0;
}
.el-upload__tip a:link,
.el-upload__tip a:visited {
  text-decoration: underline;
  color: #2c5dfe;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
}
.isfabiao {
  position: relative;
  margin-bottom: 40px;
}
.isfabiao-txt {
  color: #f00;
  padding-left: 20px;
  font-size: 12px;
}
.isfabiao-baozhi {
  position: absolute;
  left: -110px;
  top: 30px;
  color: #2c5dfe;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}
</style>
